var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5171 12.5558C17.5077 10.9573 18.2319 9.75265 19.6944 8.86437C18.8765 7.69249 17.639 7.04796 16.0077 6.92374C14.4632 6.80187 12.7733 7.82374 12.1546 7.82374C11.5007 7.82374 10.0054 6.96593 8.82881 6.96593C6.40069 7.00343 3.82022 8.90187 3.82022 12.7644C3.82022 13.9058 4.02881 15.0847 4.446 16.2987C5.00381 17.8972 7.01475 21.8136 9.11241 21.7503C10.2093 21.7245 10.9851 20.9722 12.4124 20.9722C13.7976 20.9722 14.5148 21.7503 15.7382 21.7503C17.8546 21.7198 19.6733 18.1597 20.203 16.5566C17.3648 15.2183 17.5171 12.6378 17.5171 12.5558ZM15.0538 5.40734C16.2421 3.9964 16.1343 2.71202 16.0991 2.25031C15.0491 2.31124 13.8351 2.96515 13.1437 3.76906C12.3819 4.63156 11.9343 5.69796 12.0304 6.90031C13.1648 6.98702 14.2007 6.40343 15.0538 5.40734Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.e33252b99500c3c6fa9d87c742a72000.svg";
export { ForwardRef as ReactComponent };